import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import Avatar from '@material-ui/core/Avatar';
 import Lightbox from 'react-image-lightbox';
 import 'react-image-lightbox/style.css';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  TableContainer,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
  Switch
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
   // minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className,onPageChange,onStatusupdate, onPageLimit, orders, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [showpreview, setShowpreview] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [previewurl, setpreviewurl] = useState('');
  function previewimage(url)
  {
    setpreviewurl(url)
    setShowpreview(true)
  }
  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };
  const handleChange = orderindex => (event) => {

    onStatusupdate(orderindex,event.target.checked)
  };
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
    onPageChange(page)
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    onPageLimit(event.target.value)
  };

  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };

  return (
    <>
    {showpreview && (
      <Lightbox
        mainSrc={previewurl}
       // nextSrc={images[(photoIndex + 1) % images.length]}
       // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
        onCloseRequest={() => setShowpreview(false)}
        onMovePrevRequest={() =>
          alert('prev')
        }
        onMoveNextRequest={() =>
          alert('next')
        }
      />
    )}
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Brokers"
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
            <TableContainer className={classes.container}>

              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S No</TableCell>
                    <TableCell>Image</TableCell>
                    <TableCell>Broker Name</TableCell>
                    <TableCell>Broker City</TableCell>
                    <TableCell>Contact Number</TableCell>
                    {/* <TableCell>Company Name</TableCell> */}

                    <TableCell>status</TableCell>
                    <TableCell>status</TableCell>
                    <TableCell>CreatedAt</TableCell>
                    <TableCell align="center">Edit</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                        {index+1}
                       
                      </TableCell>
                      <TableCell>      
                        <Avatar alt={order.name} src={`${order.imageurl}`} onClick={() =>previewimage(order.image)} />
                      </TableCell>
                      <TableCell>{order.name}</TableCell>
                      <TableCell>{order.city}</TableCell>
                      <TableCell>{order.contact_number}</TableCell>
                      {/* <TableCell>{order.company_name}</TableCell> */}
                      <TableCell><Label
                          color={paymentStatusColors[order.status ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.status ? 'Active' : 'In Active'}
                        </Label></TableCell>
                        <TableCell>
							<Switch size="small" color="primary" checked={order.status}
							      onChange={handleChange(index)}
							/>
                      </TableCell>
                      <TableCell>
                        
                      <Typography variant="body1">
                          {moment(order.createdAt).format(
                            'DD MMM YYYY hh:mm a'
                          )}
                        </Typography>
                      </TableCell>
                     
                      <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/addbroker/${order.id}`}
                          variant="outlined"
                        >
                          Edit
                        </Button>
                      </TableCell>
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {orders.length > 0 ? "" : <Typography className={classes.nodataCont} component={"h6"} >No Records found</Typography>}

   </TableContainer>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={props.totalcount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  onPageChange: PropTypes.func,
  onPageLimit : PropTypes.func
};

Results.defaultProps = {
  orders: []
};

export default Results;
